import { useAppState } from "@/modules/app/useAppContext";
import { SnowflakeJobList } from "@/pages/query/SnowflakeJobs";
import { CustomWorkloadsJobs } from "./CustomWorkloadsJobs";
import { WorkflowType } from "@/pages/query/types";
import { useBreadcrumb } from "@/components/breadcrumbs";

interface CustomWorkloadsJobsWrapperProps {
  workflowType: WorkflowType;
}

export const CustomWorkloadsJobsWrapper = ({ workflowType }: CustomWorkloadsJobsWrapperProps) => {
  const { enableCustomWorkloadsChartAggregation } = useAppState();

  const label = workflowType === WorkflowType.TABLEAU ? "Tableau" : "Workloads";
  useBreadcrumb(label, {
    defaultParents: [{ label: "Code", pathname: "/query" }],
    truncateTo: "/query",
  });

  if (enableCustomWorkloadsChartAggregation) {
    return <CustomWorkloadsJobs workflowType={workflowType} />;
  }

  return <SnowflakeJobList workflowType={workflowType} />;
};
